import type { Manufacturer } from 'common/models';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { ServiceObjectInRelatedData } from 'pages/serviceObjects/models';
import React from 'react';

interface OwnProps {
  serviceObjects: ServiceObjectInRelatedData[];
  title?: string;
  serviceObjectManufacturers: Manufacturer[];
}

const ServiceObjectsInfoTable = (props: OwnProps) => {
  const { serviceObjects, title, serviceObjectManufacturers } = props;
  const { t } = useCustomTranslation();

  return (
    <div className="ServiceObjectsInfoTable">
      <div className="SectionTitle">{title}</div>
      <table>
        <thead>
          <tr>
            <th>{t('customData.serviceObjects.name')}</th>
            <th>{t('customData.serviceObjects.identificationNumber')}</th>
            <th>{t('customData.serviceObjects.manufacturer')}</th>
          </tr>
        </thead>
        <tbody>
          {serviceObjects.map((serviceObject) => (
            <tr key={serviceObject.id}>
              <td>{serviceObject.name}</td>
              <td>{serviceObject.identificationNumber}</td>
              <td>
                {serviceObjectManufacturers.find((x) => x.id === serviceObject.manufacturerId)
                  ?.name ||
                  serviceObject.manufacturerName ||
                  ''}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ServiceObjectsInfoTable;
